import React, { FC } from 'react';
import { SCUIGeneralModal } from '../../../../atomic/molecules';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SS_BS } from './searchServiceAddToListModal.classes';

export const SCUISearchServiceAddToListModal: FC<{
    open: boolean;
    onClose: any;
    orderNo: any;
    setOrderNo: any;
    listele?: any;
    text?: any;
}> = ({ open, onClose, orderNo, setOrderNo, listele, text }) => {
    const { t } = useTranslation();

    return (
        <SCUIGeneralModal
            width={'xs'}
            open={open}
            onClose={onClose}
            title={t('general.batchSearch')}
            functionButtonOnClick={listele}
            buttonText={t('general.search')}
            rootClassName={SS_BS.modalRoot}
            paperClassName={SS_BS.modalPaper}
            titleClassName={SS_BS.modalTitle}
            closeIconButtonClassName={SS_BS.modalCloseButton}
            closeIconClassName={SS_BS.modalCloseIcon}
        >
            <Grid className={SS_BS.content} container sx={{ padding: '2rem' }}>
                <TextField
                    className={SS_BS.input}
                    sx={{ paddingBottom: '1rem' }}
                    label={text}
                    value={orderNo}
                    multiline
                    rows={10}
                    onChange={(event: any) => {
                        setOrderNo(event.target.value);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                />
            </Grid>
        </SCUIGeneralModal>
    );
};
